app.service('partnerBar', function (loading, cookie, html) {
	var $self;

	function logoutPartner() {
		loading.redirect('/konto-wyloguj.bhtml');
	}
	function init() {
		$self = $('#top-operator-bar');
		if ($self.length && $('.partner-bar', $self).length) {
			html.add('partner-logged');
			$('.js-logout-partner', $self).click(function(){
				logoutPartner();
			});
		}
	}
	return {
		init
	};
});
